module.exports = __webpack_public_path__ + "assets/img/img-wechat-pay.4795736a.png";